import React, { useRef } from 'react';
import { AudioTrackInfo } from 'components/organisms/gen-ai-audio-tool/GenAITool';
import * as Styled from './AudioCardSection.styled';
import { AudioCard } from './AudioCard';

export interface Audio {
  name: string;
  image: string;
  audio: string;
  audioId: string;
}

export interface AudioCardSectionProps {
  className?: string;
  selected: number;
  /* eslint-disable no-unused-vars */
  onChange: (idx: number) => void;
  audioTracks: Audio[];
  currentAudioId: string;
  title: string;
  caption: string;
  type?: 'voice' | 'music';
  handlePlayAudio: (
    trackInfo: Pick<AudioTrackInfo, 'id' | 'audioElement'> & {
      playFromStart?: boolean;
    },
  ) => void;
  handlePauseAudio: () => void;
  handleAudioEnded: () => void;
}

export const AudioCardSection: React.FC<AudioCardSectionProps> = ({
  className,
  selected,
  onChange,
  audioTracks,
  currentAudioId,
  title,
  caption,
  type = 'voice',
  handlePlayAudio,
  handlePauseAudio,
  handleAudioEnded,
}) => {
  const audioRefs = useRef<(HTMLAudioElement | null)[]>([]);

  const handlePlayClick = (idx: number) => (e: React.MouseEvent) => {
    e.stopPropagation();
    if (currentAudioId === audioTracks[idx].audioId && audioRefs.current[idx]) {
      if (audioRefs.current[idx]?.paused) {
        handlePlayAudio({
          id: audioTracks[idx].audioId,
          audioElement: audioRefs.current[idx],
        });
      } else {
        handlePauseAudio();
      }
    } else {
      handlePlayAudio({
        id: audioTracks[idx].audioId,
        audioElement: audioRefs.current[idx],
        playFromStart: true,
      });
    }
  };

  return (
    <Styled.Section className={className}>
      <Styled.Title>{title}</Styled.Title>
      <Styled.Row>
        {audioTracks.map((audioTrack, idx) => (
          <AudioCard
            key={audioTrack.name}
            audio={audioTrack}
            selected={selected === idx}
            onSelect={() => onChange(idx)}
            playing={
              currentAudioId === audioTracks[idx].audioId &&
              !audioRefs.current[idx]?.paused
            }
            onPlayClick={handlePlayClick(idx)}
            onAudioEnded={handleAudioEnded}
            audioRef={el => {
              audioRefs.current[idx] = el;
              return el;
            }}
            type={type}
          />
        ))}
      </Styled.Row>
      <Styled.Caption>{caption}</Styled.Caption>
    </Styled.Section>
  );
};
